import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { FormattedCurrency } from '../../../../../../../components/formatted-currency';
import { getDiscountedValues } from '../../../migrate-plan-modal/helpers';
import { useAdditionalAnalyticsLicenseCountCostForBillingPlanId } from '../../../../hooks/use-plan-details';

import { messages } from './messages';

import style from '../plan-details.module.css';

type AnalyticsLicenseCostProps = {
  billingPlanId: string;
  additionalLicenses: number;
  discountPercent?: number;
};

export const AnalyticsLicenseCost = ({ billingPlanId, additionalLicenses, discountPercent }: AnalyticsLicenseCostProps) => {
  const cost = useAdditionalAnalyticsLicenseCountCostForBillingPlanId(billingPlanId, additionalLicenses);

  if (!cost?.value) {
    return (
      <Text
        className={style['plan-option-content-cost']}
        element='span'
        textType={TextType.Caption}
        value={<FormattedMessage {...messages.includedAbbreviation} />}
      />
    );
  }

  const hasDiscount = discountPercent != null && discountPercent > 0;
  const discountedPrice = hasDiscount
    ? getDiscountedValues({ fullPrice: cost.value, discountPercentage: discountPercent / 100 }).discountedPrice
    : 0;

  const message = hasDiscount ? (
    <FormattedMessage
      {...messages.analyticsLicenseAdditionalCost}
      values={{
        cost: (
          <>
            <span className={style['plan-option-content-cost-strikethrough']}>
              <FormattedCurrency currencyCode={cost.code} value={cost.value} />
            </span>
            <FormattedCurrency currencyCode={cost.code} value={discountedPrice} />
          </>
        ),
      }}
    />
  ) : (
    <FormattedMessage
      {...messages.analyticsLicenseAdditionalCost}
      values={{
        cost: <FormattedCurrency currencyCode={cost.code} value={cost.value} />,
      }}
    />
  );

  return <Text className={style['plan-option-content-cost']} element='span' textType={TextType.Caption} value={message} />;
};
